import { render, staticRenderFns } from "./addFullFift.vue?vue&type=template&id=c3adf1aa&scoped=true&"
import script from "./addFullFift.vue?vue&type=script&lang=js&"
export * from "./addFullFift.vue?vue&type=script&lang=js&"
import style0 from "./addFullFift.vue?vue&type=style&index=0&id=c3adf1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3adf1aa",
  null
  
)

export default component.exports